import { render, staticRenderFns } from "./_search_course_list_item.vue?vue&type=template&id=22ecb356"
import script from "./_search_course_list_item.vue?vue&type=script&lang=js"
export * from "./_search_course_list_item.vue?vue&type=script&lang=js"
import style0 from "./_search_course_list_item.vue?vue&type=style&index=0&id=22ecb356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports